import { refreshUser } from '@/api/user.js';
import { checkLogin } from '@/scripts/token.js';
import constants from '@/constants';
import router from '@/router';

class TokenRefreshService {
    constructor() {
        this.intervalId = null;
        this.refreshInterval = 60000; // Fixed: 1 minute in milliseconds
        this.isRefreshing = false;
    }

    /**
     * Start the automatic token refresh service
     */
    start() {
        // Don't start if already running
        if (this.intervalId) {
            return;
        }

        this.intervalId = setInterval(async () => {
            await this.performRefresh();
        }, this.refreshInterval);

        // Also perform an initial refresh
        this.performRefresh();
    }

    /**
     * Stop the automatic token refresh service
     */
    stop() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    /**
     * Perform token refresh if user is logged in and not on auth page
     */
    async performRefresh() {
        // Skip if already refreshing
        if (this.isRefreshing) {
            return;
        }

        // Skip if user is on authorization page
        if (
            router.currentRoute.value.name ===
            constants.ROUTER_NAME.AUTHORIZATION
        ) {
            return;
        }

        // Skip if user is not logged in
        const isLoggedIn = await checkLogin();
        if (!isLoggedIn) {
            return;
        }

        try {
            this.isRefreshing = true;

            await refreshUser();
        } catch (error) {
            // The refreshUser function already handles logout on failure
        } finally {
            this.isRefreshing = false;
        }
    }

    /**
     * Check if service is running
     */
    isRunning() {
        return this.intervalId !== null;
    }
}

// Create singleton instance
const tokenRefreshService = new TokenRefreshService();

export default tokenRefreshService;
